// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.form-control {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid #ccc !important;
}
input.form-control:focus {
  border-color: blue !important;
}

button.btn,
input {
  width: 100%;
  max-width: 350px;
}

.img {
  width: 100%;
  max-width: 280px;
  min-width: 150px;
  margin-bottom: 40px;
}

p,
.back-btn {
  color: #999;
}

.forgot-pass {
  height: 100vh;
  padding-top: 80px;
}
.forgot-pass .forgot-pass-form {
  width: 100%;
  max-width: 350px;
}
.forgot-pass .desc {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.check img {
  width: 125px;
  height: 125px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBhc3N3b3JkLXJlc2V0LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBO0VBQ0Usd0JBQUE7RUFDQSwyQkFBQTtFQUNBLGlDQUFBO0FBREY7QUFHRTtFQUNFLDZCQUFBO0FBREo7O0FBS0E7O0VBRUUsV0FBQTtFQUNBLGdCQWZpQjtBQWFuQjs7QUFLQTtFQUNFLFdBQUE7RUFDQSxnQkFBQTtFQUNBLGdCQUFBO0VBQ0EsbUJBQUE7QUFGRjs7QUFLQTs7RUFFRSxXQUFBO0FBRkY7O0FBS0E7RUFDRSxhQUFBO0VBQ0EsaUJBQUE7QUFGRjtBQUtFO0VBQ0UsV0FBQTtFQUNBLGdCQXJDZTtBQWtDbkI7QUFNRTtFQUNFLGdCQUFBO0VBQ0EsaUJBQUE7RUFDQSxrQkFBQTtBQUpKOztBQVNFO0VBQ0UsWUFBQTtFQUNBLGFBQUE7QUFOSiIsImZpbGUiOiJwYXNzd29yZC1yZXNldC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIiRmb3JtX2lucHV0X3dpZHRoOiAzNTBweDtcblxuaW5wdXQuZm9ybS1jb250cm9sIHtcbiAgb3V0bGluZTogbm9uZSAhaW1wb3J0YW50O1xuICBib3gtc2hhZG93OiBub25lICFpbXBvcnRhbnQ7XG4gIGJvcmRlcjogMXB4IHNvbGlkICNjY2MgIWltcG9ydGFudDtcblxuICAmOmZvY3VzIHtcbiAgICBib3JkZXItY29sb3I6IGJsdWUgIWltcG9ydGFudDtcbiAgfVxufVxuXG5idXR0b24uYnRuLFxuaW5wdXQge1xuICB3aWR0aDogMTAwJTtcbiAgbWF4LXdpZHRoOiAkZm9ybV9pbnB1dF93aWR0aDtcbn1cblxuLmltZyB7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXgtd2lkdGg6IDI4MHB4O1xuICBtaW4td2lkdGg6IDE1MHB4O1xuICBtYXJnaW4tYm90dG9tOiA0MHB4O1xufVxuXG5wLFxuLmJhY2stYnRuIHtcbiAgY29sb3I6ICM5OTk7XG59XG5cbi5mb3Jnb3QtcGFzcyB7XG4gIGhlaWdodDogMTAwdmg7XG4gIHBhZGRpbmctdG9wOiA4MHB4O1xuICAvLyAgIGJhY2tncm91bmQtY29sb3I6ICNlZWZjZmY7XG5cbiAgLmZvcmdvdC1wYXNzLWZvcm0ge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIG1heC13aWR0aDogJGZvcm1faW5wdXRfd2lkdGg7XG4gIH1cblxuICAuZGVzYyB7XG4gICAgbWF4LXdpZHRoOiAzMDBweDtcbiAgICBtYXJnaW4tbGVmdDogYXV0bztcbiAgICBtYXJnaW4tcmlnaHQ6IGF1dG87XG4gIH1cbn1cblxuLmNoZWNrIHtcbiAgaW1nIHtcbiAgICB3aWR0aDogMTI1cHg7XG4gICAgaGVpZ2h0OiAxMjVweDtcbiAgfVxufVxuIl19 */`, "",{"version":3,"sources":["webpack://./libs/auth/src/lib/components/password-reset/password-reset.component.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;EACA,2BAAA;EACA,iCAAA;AADF;AAGE;EACE,6BAAA;AADJ;;AAKA;;EAEE,WAAA;EACA,gBAfiB;AAanB;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;;EAEE,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,iBAAA;AAFF;AAKE;EACE,WAAA;EACA,gBArCe;AAkCnB;AAME;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAJJ;;AASE;EACE,YAAA;EACA,aAAA;AANJ;AACA,ooDAAooD","sourcesContent":["$form_input_width: 350px;\n\ninput.form-control {\n  outline: none !important;\n  box-shadow: none !important;\n  border: 1px solid #ccc !important;\n\n  &:focus {\n    border-color: blue !important;\n  }\n}\n\nbutton.btn,\ninput {\n  width: 100%;\n  max-width: $form_input_width;\n}\n\n.img {\n  width: 100%;\n  max-width: 280px;\n  min-width: 150px;\n  margin-bottom: 40px;\n}\n\np,\n.back-btn {\n  color: #999;\n}\n\n.forgot-pass {\n  height: 100vh;\n  padding-top: 80px;\n  //   background-color: #eefcff;\n\n  .forgot-pass-form {\n    width: 100%;\n    max-width: $form_input_width;\n  }\n\n  .desc {\n    max-width: 300px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.check {\n  img {\n    width: 125px;\n    height: 125px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
